import React from 'react';

export interface ArticleImageData {
  url: string;
  sujet: string;
  credit: string;
  page?: string | null;
}

/**
 * Image d'illustration d'un article (siège ou activité de la société, siège de la BRVM par défaut),
 * choisie par l'API à l'affichage (`api/app/article_image.py`). Le crédit est obligatoire sous
 * l'image (licences CC BY / BY-SA) : il est toujours affiché, avec un lien vers la page source.
 */
const ArticleImage: React.FC<{ image?: ArticleImageData | null }> = ({ image }) => {
  if (!image) return null;
  return (
    <figure style={{ margin: '0 0 16px 0' }}>
      <img
        src={image.url}
        alt={image.sujet}
        loading='lazy'
        decoding='async'
        style={{ display: 'block', width: '100%', height: 'auto', aspectRatio: '1200 / 630', objectFit: 'cover', borderRadius: '8px' }}
      />
      <figcaption style={{ marginTop: '4px', fontSize: '11px', color: '#94a3b8' }}>
        {image.sujet}.{' '}
        {image.page ? (
          <a href={image.page} target='_blank' rel='noopener noreferrer' style={{ color: 'inherit' }}>
            {image.credit}
          </a>
        ) : (
          image.credit
        )}
      </figcaption>
    </figure>
  );
};

export default ArticleImage;
